import { render, staticRenderFns } from "./CommonConfirmFrame.vue?vue&type=template&id=19e0db15&scoped=true&"
import script from "./CommonConfirmFrame.vue?vue&type=script&lang=js&"
export * from "./CommonConfirmFrame.vue?vue&type=script&lang=js&"
import style0 from "./CommonConfirmFrame.vue?vue&type=style&index=0&id=19e0db15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e0db15",
  null
  
)

export default component.exports